import { render, staticRenderFns } from "./DynamicHeading.vue?vue&type=template&id=f96e0f6a&"
import script from "./DynamicHeading.vue?vue&type=script&lang=js&"
export * from "./DynamicHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports